
import { Layout } from 'antd';
import './GeneralHeader.less';
import HeaderRightFirstRow from './HeaderElements/HeaderRightFirstRow';
import HeaderLeft from './HeaderElements/HeaderLeft';
import { useAuth } from '../../../hooks/auth/AuthContext';

const { Header } = Layout;

const GeneralHeader = () => {
  const { authState } = useAuth();

  return (
    <Header className="site-layout-header" >
      <div className='header-left-elements'>
        <HeaderLeft />
      </div>
      <div className={authState?.isLogin ? 'header-right-elements-login' : 'header-right-elements'}>
        <HeaderRightFirstRow />
      </div>
    </Header>
  )
}

export default GeneralHeader;